import React from 'react';
import {FluidContainer} from './styles';

export default ({children, overflow = false}: {children: React.ReactNode; overflow?: boolean}) => (
  <FluidContainer overflow={overflow.toString()}>{children}</FluidContainer>
);
